<div class="wrap wrapHead">
  <div class="pageHead">
    <h1>Please contact {{ helpEmail }} for assistance.</h1>
  </div>
</div>
